const brvmUniverseSnapshot = {
  "asOf": "2026-04-03T16:13:45.940Z",
  "generatedAt": "2026-04-03T16:13:45.940Z",
  "source": "brvm-public-api-snapshot",
  "count": 47,
  "rows": [
    {
      "symbol": "ABJC",
      "name": "SERVAIR ABIDJAN COTE D'IVOIRE",
      "sector": "CONSOMMATION DISCRETIONNAIRE",
      "price": 3600
    },
    {
      "symbol": "BICB",
      "name": "BANQUE INTERNATIONALE POUR L’INDUSTRIE ET LE COMMERCE DU BENIN",
      "sector": "SERVICES FINANCIERS",
      "price": 5175
    },
    {
      "symbol": "BICC",
      "name": "BICI COTE D'IVOIRE",
      "sector": "SERVICES FINANCIERS",
      "price": 24000
    },
    {
      "symbol": "BNBC",
      "name": "BERNABE COTE D'IVOIRE",
      "sector": "CONSOMMATION DISCRETIONNAIRE",
      "price": 1515
    },
    {
      "symbol": "BOAB",
      "name": "BANK OF AFRICA BENIN",
      "sector": "SERVICES FINANCIERS",
      "price": 7600
    },
    {
      "symbol": "BOABF",
      "name": "BANK OF AFRICA BURKINA FASO",
      "sector": "SERVICES FINANCIERS",
      "price": 5590
    },
    {
      "symbol": "BOAC",
      "name": "BANK OF AFRICA COTE D'IVOIRE",
      "sector": "SERVICES FINANCIERS",
      "price": 8495
    },
    {
      "symbol": "BOAM",
      "name": "BANK OF AFRICA MALI",
      "sector": "SERVICES FINANCIERS",
      "price": 4685
    },
    {
      "symbol": "BOAN",
      "name": "BANK OF AFRICA NIGER",
      "sector": "SERVICES FINANCIERS",
      "price": 2660
    },
    {
      "symbol": "BOAS",
      "name": "BANK OF AFRICA SENEGAL",
      "sector": "SERVICES FINANCIERS",
      "price": 6800
    },
    {
      "symbol": "CABC",
      "name": "SICABLE COTE D'IVOIRE",
      "sector": "INDUSTRIELS",
      "price": 3945
    },
    {
      "symbol": "CBIBF",
      "name": "CORIS BANK INTERNATIONAL BURKINA FASO",
      "sector": "SERVICES FINANCIERS",
      "price": 15005
    },
    {
      "symbol": "CFAC",
      "name": "CFAO MOTORS COTE D'IVOIRE",
      "sector": "CONSOMMATION DISCRETIONNAIRE",
      "price": 1620
    },
    {
      "symbol": "CIEC",
      "name": "CIE COTE D'IVOIRE",
      "sector": "SERVICES PUBLICS",
      "price": 3400
    },
    {
      "symbol": "ECOC",
      "name": "ECOBANK COTE D'IVOIRE",
      "sector": "SERVICES FINANCIERS",
      "price": 16350
    },
    {
      "symbol": "ETIT",
      "name": "Ecobank Transnational Incorporated TOGO",
      "sector": "SERVICES FINANCIERS",
      "price": 34
    },
    {
      "symbol": "FTSC",
      "name": "FILTISAC COTE D'IVOIRE",
      "sector": "INDUSTRIELS",
      "price": 2350
    },
    {
      "symbol": "LNBB",
      "name": "LOTERIE NATIONALE DU BENIN",
      "sector": "CONSOMMATION DISCRETIONNAIRE",
      "price": 3850
    },
    {
      "symbol": "NEIC",
      "name": "NEI-CEDA COTE D'IVOIRE",
      "sector": "CONSOMMATION DISCRETIONNAIRE",
      "price": 1400
    },
    {
      "symbol": "NSBC",
      "name": "NSIA BANQUE COTE D'IVOIRE",
      "sector": "SERVICES FINANCIERS",
      "price": 14180
    },
    {
      "symbol": "NTLC",
      "name": "NESTLE COTE D'IVOIRE",
      "sector": "CONSOMMATION DE BASE",
      "price": 12300
    },
    {
      "symbol": "ONTBF",
      "name": "ONATEL BURKINA FASO",
      "sector": "TELECOMMUNICATIONS",
      "price": 2935
    },
    {
      "symbol": "ORAC",
      "name": "ORANGE COTE D'IVOIRE",
      "sector": "TELECOMMUNICATIONS",
      "price": 15000
    },
    {
      "symbol": "ORGT",
      "name": "ORAGROUP TOGO",
      "sector": "SERVICES FINANCIERS",
      "price": 3660
    },
    {
      "symbol": "PALC",
      "name": "PALM COTE D'IVOIRE",
      "sector": "CONSOMMATION DE BASE",
      "price": 8150
    },
    {
      "symbol": "PRSC",
      "name": "TRACTAFRIC MOTORS COTE D'IVOIRE",
      "sector": "CONSOMMATION DISCRETIONNAIRE",
      "price": 4760
    },
    {
      "symbol": "SAFC",
      "name": "SAFCA COTE D'IVOIRE",
      "sector": "SERVICES FINANCIERS",
      "price": 7445
    },
    {
      "symbol": "SCRC",
      "name": "SUCRIVOIRE COTE D'IVOIRE",
      "sector": "CONSOMMATION DE BASE",
      "price": 1945
    },
    {
      "symbol": "SDCC",
      "name": "SODE COTE D'IVOIRE",
      "sector": "SERVICES PUBLICS",
      "price": 7400
    },
    {
      "symbol": "SDSC",
      "name": "AFRICA GLOBAL LOGISTICS COTE D'IVOIRE",
      "sector": "INDUSTRIELS",
      "price": 1860
    },
    {
      "symbol": "SEMC",
      "name": "EVIOSYS PACKAGING SIEM COTE D'IVOIRE",
      "sector": "INDUSTRIELS",
      "price": 1985
    },
    {
      "symbol": "SGBC",
      "name": "SOCIETE GENERALE COTE D'IVOIRE",
      "sector": "SERVICES FINANCIERS",
      "price": 34200
    },
    {
      "symbol": "SHEC",
      "name": "VIVO ENERGY COTE D'IVOIRE",
      "sector": "ENERGIE",
      "price": 2200
    },
    {
      "symbol": "SIBC",
      "name": "SOCIETE IVOIRIENNE DE BANQUE COTE D'IVOIRE",
      "sector": "SERVICES FINANCIERS",
      "price": 7000
    },
    {
      "symbol": "SICC",
      "name": "SICOR COTE D'IVOIRE",
      "sector": "CONSOMMATION DE BASE",
      "price": 4000
    },
    {
      "symbol": "SIVC",
      "name": "ERIUM COTE D’IVOIRE",
      "sector": "INDUSTRIELS",
      "price": 2940
    },
    {
      "symbol": "SLBC",
      "name": "SOLIBRA COTE D'IVOIRE",
      "sector": "CONSOMMATION DE BASE",
      "price": 38900
    },
    {
      "symbol": "SMBC",
      "name": "SMB COTE D'IVOIRE",
      "sector": "ENERGIE",
      "price": 12000
    },
    {
      "symbol": "SNTS",
      "name": "SONATEL SENEGAL",
      "sector": "TELECOMMUNICATIONS",
      "price": 29000
    },
    {
      "symbol": "SOGC",
      "name": "SOGB COTE D'IVOIRE",
      "sector": "CONSOMMATION DE BASE",
      "price": 7710
    },
    {
      "symbol": "SPHC",
      "name": "SAPH COTE D'IVOIRE",
      "sector": "CONSOMMATION DE BASE",
      "price": 7000
    },
    {
      "symbol": "STAC",
      "name": "SETAO COTE D'IVOIRE",
      "sector": "INDUSTRIELS",
      "price": 3375
    },
    {
      "symbol": "STBC",
      "name": "SITAB COTE D'IVOIRE",
      "sector": "CONSOMMATION DE BASE",
      "price": 21500
    },
    {
      "symbol": "TTLC",
      "name": "TOTALENERGIES MARKETING COTE D'IVOIRE",
      "sector": "ENERGIE",
      "price": 2705
    },
    {
      "symbol": "TTLS",
      "name": "TOTALENERGIES MARKETING SENEGAL",
      "sector": "ENERGIE",
      "price": 3390
    },
    {
      "symbol": "UNLC",
      "name": "UNILEVER COTE D'IVOIRE",
      "sector": "CONSOMMATION DE BASE",
      "price": 69005
    },
    {
      "symbol": "UNXC",
      "name": "UNIWAX COTE D'IVOIRE",
      "sector": "CONSOMMATION DISCRETIONNAIRE",
      "price": 1925
    }
  ]
};

export default brvmUniverseSnapshot;
